// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
    font-family: sans-serif;
    text-align: center;
  }
  
  /* img {
    max-width: 150px;
    height: 15rem;
    padding: 0 15px;
    object-fit: cover;
  } */
  
  img:last-of-type {
    padding-left: 0;
  }

  /* object {
    max-width: 150px;
    height: 15rem;
    padding: 0 15px;
    object-fit: cover;
  } */
  
  object:last-of-type {
    padding-left: 0;
  }
  
  .inner {
    position: relative;
    width: 100%;
    overflow: hidden;
    height: 15rem;
  }
  
  .wrapper {
    /* position: absolute; */
    display: flex;
  }
  
  .banner-grid {
    /* display: grid; */
    gap: 1rem;
    width: 100%;
  }

  /* @media (max-width: 1024px) {
    .banner-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media (max-width: 640px) {
    .banner-grid {
      grid-template-columns: 1fr;
    }
  } */

  .banner-grid .image {
    position: relative;
    overflow: hidden;
    border-radius: 0.75rem;
    height: 15rem;
  }

  .banner-grid .image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
`, "",{"version":3,"sources":["webpack://./pages/styles.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;;;;;KAKG;;EAEH;IACE,eAAe;EACjB;;EAEA;;;;;KAKG;;EAEH;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,WAAW;EACb;;EAEA;;;;;;;;;;KAUG;;EAEH;IACE,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB","sourcesContent":[".App {\n    font-family: sans-serif;\n    text-align: center;\n  }\n  \n  /* img {\n    max-width: 150px;\n    height: 15rem;\n    padding: 0 15px;\n    object-fit: cover;\n  } */\n  \n  img:last-of-type {\n    padding-left: 0;\n  }\n\n  /* object {\n    max-width: 150px;\n    height: 15rem;\n    padding: 0 15px;\n    object-fit: cover;\n  } */\n  \n  object:last-of-type {\n    padding-left: 0;\n  }\n  \n  .inner {\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n    height: 15rem;\n  }\n  \n  .wrapper {\n    /* position: absolute; */\n    display: flex;\n  }\n  \n  .banner-grid {\n    /* display: grid; */\n    gap: 1rem;\n    width: 100%;\n  }\n\n  /* @media (max-width: 1024px) {\n    .banner-grid {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n  }\n\n  @media (max-width: 640px) {\n    .banner-grid {\n      grid-template-columns: 1fr;\n    }\n  } */\n\n  .banner-grid .image {\n    position: relative;\n    overflow: hidden;\n    border-radius: 0.75rem;\n    height: 15rem;\n  }\n\n  .banner-grid .image img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  \n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
